import entj from './entj';
import esfj from './esfj';
import infp from './infp';
import intj from './intj';
import intp from './intp';
import isfp from './isfp';
import istj from './istj';

export default {
  intj,
  isfp,
  esfj,
  infp,
  entj,
  istj,
  intp
};
